<template>
  <v-card>
    <!-- botonera superior de la aplicacion  -->
    <v-card-title class="buttonBar">
      <div style='width:100% '>
        <div class="headline" style="float: left;">
          <v-btn icon @click="vuelveListado()" style="margin: 0px">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span>{{ $t('resumenPresupuesto') }} : {{ this.presupuesto.numeroPedido }}
          </span>
        </div>
        <div style="float: right;">
          <v-btn color="green darken-1 white--text" value="asistente" @click="fEditaPresupuesto()">
            <v-icon>mdi-pencil</v-icon>
            <span>{{ $t('editar') }}</span>
          </v-btn>
        </div>
      </div>
    </v-card-title>

    <!-- visualizador de presupuestos PDF  -->
    <v-card-text id="pdf">
      <iframe :src="presupuestoPDF" width="100%" height="700px" title="Presupuestos"></iframe>
    </v-card-text>

    <div style="flex: 1 1 auto;"></div>
  </v-card>

</template>

<script>

// SERVICES
import SrvPres from '@/services/srv-presupuestos'

const ORIGEN_RESUMEN = 'resumen'

export default {
  name: 'PreResumen',
  props: {
    origen: {
      type: String,
      required: true
    },
    presupuesto: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      presupuestoPDF: ''
    }
  },
  created() {
    // carga el presupuesto pasado por valor
    this.muestraPresupuestoPDF()
  },
  methods: {
    /*
     * carga la pagina del aistente para editar el presupuesto
     */
    fEditaPresupuesto() {
      this.$emit('goToAsistente', this.presupuesto, ORIGEN_RESUMEN)
    },
    /*
     * vuelve al lista de presupuestos
     */
    vuelveListado() {
      this.$emit('goToListado')
    },
    /*
     * Carga el presupuesto de un WebService
     */
    muestraPresupuestoPDF() {
      this.$emit('loading', this.$t('iniImpresPres'))
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        idPresupuesto: this.presupuesto.id,
        formato: 'I',
        desformat: 'PDF'
      }
      SrvPres.getImpresionPresupuesto(payload).then(response => {
          if (response.data.statusCode === '200') {
            this.presupuestoPDF = response.data.urlEtiqueta
          } else {
            this.$emit('alert', '<b>obtiene url informe</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ') ')
          }
          this.$emit('loading', '')
        }).catch(error => {
          this.fErrorComprobado(error)
          this.$emit('loading', '')
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpResumen.vue